import { IEntry, IRunner } from '@amwager/util-ts';
import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({
  name: 'getRunner',
  standalone: true
})
export class GetRunnerPipe implements PipeTransform {

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(runners?: IRunner[] | any, position?: string): IEntry | undefined {
    if (!runners || !position) return;

    let toReturn: IEntry | undefined;

    _.map(runners, (runner) => {
      _.map(runner?.Entries, (entry) => {
        if (
          Number(runner?.RunnerId) === Number(position)
          // || Number(entry?.Position) === Number(position)
        ) toReturn = entry;
      })

      if (runner?.Entries === undefined)
        if ((Number(runner?.Id))=== Number(position))
          toReturn = runner;
    });

    return toReturn;
  }

}
